import { EnumCountryKey } from "src/types/common-enum";
import { EnumSearchQueryParams } from "../search.types";

export const mapIsInvestableToQuery = (isInvestable: boolean) => {
    return isInvestable ? `${EnumSearchQueryParams.IsInvestable}=true` : "";
};

export const mapIsChInvestableToQuery = (isChInvestable: boolean, country: string) => {
    return isChInvestable && country === EnumCountryKey.CH ? `${EnumSearchQueryParams.IsChInvestable}=true` : "";
};

export const mapIsAtInvestableToQuery = (isAtInvestable: boolean, country: string) => {
    return isAtInvestable && country === EnumCountryKey.AT ? `${EnumSearchQueryParams.IsAtInvestable}=true` : "";
};
